<div class="flex flex-col gap-8">
  <pr-information-box class="mt-2">
    <p>
      Webhooks provide a way for you to be notified when something happens in a
      Principle account that you have been granted access for. For more
      information, please refer to the
      <a
        target="_blank"
        class="inline-flex items-center gap-2"
        [href]="apiDocsUrl"
      >
        <span>API Docs</span>
        <mat-icon class="icon-sm">open_in_new</mat-icon>
      </a>
    </p>
  </pr-information-box>

  <mat-card>
    <mat-card-header class="flex justify-between">
      <mat-card-title>Webhooks</mat-card-title>
      <mat-card-subtitle>Manage your webhooks</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div class="flex flex-col gap-4">
        <mat-list>
          @for (webhook of webhooks$ | async; track webhook.ref.path) {
            <mat-list-item>
              <span matListItemTitle>{{ webhook.label }}</span>

              <div matListItemLine>
                <span class="mat-caption text-sm"
                  >Endpoint Url: {{ webhook.endpointUrl }}</span
                >
              </div>

              <div matListItemLine>
                <span class="mat-caption text-sm"
                  >Created:
                  {{
                    webhook.createdAt | moment | amDateFormat: dateFormat
                  }}</span
                >
              </div>

              <div matListItemLine>
                <span class="mat-caption text-sm"
                  >Signature: {{ webhook.secret }}</span
                >
              </div>

              <div matListItemMeta>
                <div class="flex h-full items-center gap-2">
                  <pr-webhook-status dense [status]="webhook.status" />

                  <button mat-icon-button [matMenuTriggerFor]="moreMenu">
                    <mat-icon>more_vert</mat-icon>
                  </button>

                  <mat-menu #moreMenu="matMenu">
                    <ng-template matMenuContent>
                      <button mat-menu-item (click)="testWebhook(webhook)">
                        <mat-icon color="accent">schedule_send</mat-icon>
                        <span>Test Webhook</span>
                      </button>

                      @if (webhook.status === enabledWebhookStatus) {
                        <button mat-menu-item (click)="disableWebhook(webhook)">
                          <mat-icon color="warn">pause</mat-icon>
                          <span>Disable</span>
                        </button>
                      } @else {
                        <button mat-menu-item (click)="enableWebhook(webhook)">
                          <mat-icon color="accent">play_arrow</mat-icon>
                          <span>Enable</span>
                        </button>
                      }
                      <button mat-menu-item (click)="deleteWebhook(webhook)">
                        <mat-icon color="warn">delete</mat-icon>
                        <span>Delete</span>
                      </button>
                    </ng-template>
                  </mat-menu>
                </div>
              </div>
            </mat-list-item>
          } @empty {
            <pr-empty-state
              type="text"
              explicitTitle="Add a Webhook to get started. Webhooks can be added via the API."
            >
              <div class="flex justify-between pt-2">
                <a
                  target="_blank"
                  class="flex items-center gap-2"
                  [href]="apiDocsUrl"
                >
                  <span>View API Docs</span>
                  <mat-icon class="icon-sm">open_in_new</mat-icon>
                </a>
              </div>
            </pr-empty-state>
          }
        </mat-list>
      </div>
    </mat-card-content>
  </mat-card>
</div>
